










import { Vue, Component } from 'vue-property-decorator';
import ModuloAutorizacionBase from './ModuloAutorizacionBase.vue';

@Component({
  components: { ModuloAutorizacionBase },
})
export default class ModuloAutorizacionPantalla extends Vue {}
